module.exports = __webpack_public_path__ + "static/flags/MH-0bd030923219a7a7cdfa1024c14cda0d.gif";